import { useEffect, useState } from 'react'
import './languagePicker.css'
import { useLanguage } from '../../context/LanguageContext'
import {
  german, english, spanish, italian, polish, dutch,
  danish, french, hungarian, croatian, portuguese, czech,
  bulgarian, estonian, finnish, greek, latvian, lithuanian,
  norwegian, russian, serbian, slovak, slovenian, swedish,
  turkish, ukrainian, romanian,
} from './import'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000'

// Canonical order — flags are always shown in this sequence
const LANGUAGE_ORDER = [
  'de','en','es','it','pl','nl','da','fr','hu','hr',
  'pt','cs','bg','et','fi','el','lv','lt','nb','ro',
  'ru','sr','sk','sl','sv','tr','uk',
]

const LANGUAGE_META = {
  de: { label: 'Deutsch',    flag: german },
  en: { label: 'English',    flag: english },
  es: { label: 'Español',    flag: spanish },
  it: { label: 'Italiano',   flag: italian },
  pl: { label: 'Polski',     flag: polish },
  nl: { label: 'Nederlands', flag: dutch },
  da: { label: 'Dansk',      flag: danish },
  fr: { label: 'Français',   flag: french },
  hu: { label: 'Magyar',     flag: hungarian },
  hr: { label: 'Hrvatski',   flag: croatian },
  pt: { label: 'Português',  flag: portuguese },
  cs: { label: 'Čeština',    flag: czech },
  bg: { label: 'Български',  flag: bulgarian },
  et: { label: 'Eesti',      flag: estonian },
  fi: { label: 'Suomi',      flag: finnish },
  el: { label: 'Ελληνικά',   flag: greek },
  lv: { label: 'Latviešu',   flag: latvian },
  lt: { label: 'Lietuvių',   flag: lithuanian },
  nb: { label: 'Norsk',      flag: norwegian },
  no: { label: 'Norsk',      flag: norwegian }, // legacy alias
  ru: { label: 'Русский',    flag: russian },
  sr: { label: 'Srpski',     flag: serbian },
  sk: { label: 'Slovenčina', flag: slovak },
  sl: { label: 'Slovenščina',flag: slovenian },
  sv: { label: 'Svenska',    flag: swedish },
  tr: { label: 'Türkçe',     flag: turkish },
  uk: { label: 'Українська', flag: ukrainian },
  ro: { label: 'Română',     flag: romanian },
}

const LanguagePicker = () => {
  const { setLanguage, tenantSlug, goNext, language, allTranslations } = useLanguage()
  const t = allTranslations[language] || allTranslations['en']

  const [enabledLanguages, setEnabledLanguages] = useState(null)
  const [loading, setLoading]                   = useState(true)
  const [error, setError]                       = useState(null)

  useEffect(() => {
    if (!tenantSlug) {
      const timer = setTimeout(() => {
        const saved = sessionStorage.getItem('viGuard_tenant')
        if (!saved) {
          setError(t.no_tenant_error)
          setLoading(false)
        }
      }, 500)
      return () => clearTimeout(timer)
    }

    fetch(`${BACKEND_URL}/api/checkin/languages`, {
      headers: { 'X-Tenant-Slug': tenantSlug }
    })
      .then(res => {
        if (!res.ok) throw new Error('Could not load language settings')
        return res.json()
      })
      .then(data => {
        setEnabledLanguages(data.enabled_languages || ['de', 'en'])
        setLoading(false)
      })
      .catch(err => {
        console.error('Language fetch error:', err)
        setEnabledLanguages(['de', 'en'])
        setLoading(false)
      })
  }, [tenantSlug])

  const handleLanguageSelect = (lang) => {
    setLanguage(lang)
    goNext()
  }

  if (loading) {
    return (
      <div className="viGuard__brand section__padding">
        <p className="lp-loading-text">{t.loading}</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="viGuard__brand section__padding">
        <p className="lp-error-text">{error}</p>
      </div>
    )
  }

  // Sort by canonical order so flags are always in the same positions
  const sortedLanguages = [...enabledLanguages].sort(
    (a, b) => LANGUAGE_ORDER.indexOf(a) - LANGUAGE_ORDER.indexOf(b)
  )

  return (
    <div className='viGuard__brand section__padding'>
      {sortedLanguages.map(code => {
        const meta = LANGUAGE_META[code]
        if (!meta) return null
        return (
          <div key={code}>
            <img
              src={meta.flag}
              alt={meta.label}
              title={meta.label}
              onClick={() => handleLanguageSelect(code)}
            />
          </div>
        )
      })}
    </div>
  )
}

export default LanguagePicker
